import { CHARACTER_ORDER, CHARACTER_TYPES, type CharacterKind } from '../config/characterConfig';
import type { LevelDefinition } from '../config/levelConfig';
import type { RandomManager } from '../core/RandomManager';
import { Character } from './Character';

export class CharacterFactory {
  constructor(private readonly random: RandomManager) {}

  create(level: LevelDefinition, customKind?: CharacterKind | 'random'): Character {
    const available =
      customKind && customKind !== 'random'
        ? [customKind]
        : level.characters?.length
          ? level.characters
          : CHARACTER_ORDER;
    return new Character(CHARACTER_TYPES[this.random.pick(available)]);
  }
}
